var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVercel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231 1.1A261.4 261.4 0 0 0 95.5 56.7a324 324 0 0 0-43.3 44.5A261.1 261.1 0 0 0 2.4 220.5 307.1 307.1 0 0 0 .9 278a257 257 0 0 0 219.6 231.6c14.7 2.2 42.8 2.9 57.5 1.5a257 257 0 0 0 231.6-219.6c2.2-14.7 2.9-42.8 1.5-57.5a255.8 255.8 0 0 0-55.8-138.5 324 324 0 0 0-44.5-43.3A262 262 0 0 0 291.5 2.4 395.2 395.2 0 0 0 231 1.1zm91 235l63 110.4-126.2.3c-69.4.1-126.3 0-126.5-.2s28-50.2 62.8-111a10858 10858 0 0 1 63.5-110.3L322 236.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVercel);
export default __webpack_public_path__ + "static/media/vercel.00821b8244b63f20bba4417f9e71e401.svg";
export { ForwardRef as ReactComponent };